module.exports = __webpack_public_path__ + "e1fb29eb14b04ec8ec2a986d70d813d3-811_3_2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/eightOneOne/assets/811_3_2x.png
// module id = 684
// module chunks = 0